import React, { useRef } from "react";
import PropTypes from "prop-types";
import { gql, useMutation } from "@apollo/client";

import { useAuthStore } from "../../../store/useAuthStore";
import { countFormat } from "../../../util/locale";
import { logAddToWishlist } from "../../../util/analytics";

const LIKE_PRODUCT = gql`
  mutation likeProductV2($productID: Int!) {
    likeProductV2(product_id: $productID) {
      like_count
    }
  }
`;


/**
 * 상품 카드 내 좋아요 버튼
 * @param product
 * @param isLiked
 * @param likeCount
 * @param onLikeChange
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductsListItemLikeButton({
  product,
  isLiked,
  likeCount,
  onLikeChange,
}) {
  const pendingRef = useRef(false);

  const [likeProduct] = useMutation(LIKE_PRODUCT);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isLiked) return;

    const { isLogin } = useAuthStore.getState();
    if (!isLogin) {
      alert("로그인 후 이용 가능합니다.");
      return;
    }

    if (pendingRef.current) return;
    pendingRef.current = true;

    onLikeChange({ isLiked: true, likeCount: likeCount + 1 });

    try {
      await likeProduct({ variables: { productID: Number(product.id) } });
      logAddToWishlist(product);
    } finally {
      pendingRef.current = false;
    }
  };

  return (
    <button
      className={`ProductsListItem-like${isLiked ? " ProductsListItem-like--liked" : ""}`}
      onClick={handleClick}
      aria-label="찜하기"
    >
      <svg viewBox="0 0 12.8333 11.375" fill="none">
        {isLiked ? (
          <path d="M9.02083 0.583334C7.97775 0.583334 7.05715 0.994839 6.47044 2.08391C6.44764 2.12623 6.3857 2.12623 6.3629 2.08391C5.77619 0.994839 4.85558 0.583334 3.8125 0.583334C2.95637 0.584319 2.13558 0.93202 1.5302 1.55015C0.924823 2.16829 0.584298 3.00638 0.583333 3.88055C0.583333 7.60322 5.98906 10.6165 6.21927 10.7409C6.27995 10.7742 6.34777 10.7917 6.41667 10.7917C6.48556 10.7917 6.55339 10.7742 6.61406 10.7409C6.84427 10.6165 12.25 7.60322 12.25 3.88055C12.249 3.00638 11.9085 2.16829 11.3031 1.55015C10.6978 0.93202 9.87697 0.584319 9.02083 0.583334Z" />
        ) : (
          <path d="M9.02083 0.583334C7.94531 0.583334 7.00365 1.05558 6.41667 1.85383C5.82969 1.05558 4.88802 0.583334 3.8125 0.583334C2.95637 0.584319 2.13558 0.93202 1.5302 1.55015C0.924823 2.16829 0.584298 3.00638 0.583333 3.88055C0.583333 7.60322 5.98906 10.6165 6.21927 10.7409C6.27995 10.7742 6.34777 10.7917 6.41667 10.7917C6.48556 10.7917 6.55339 10.7742 6.61406 10.7409C6.84427 10.6165 12.25 7.60322 12.25 3.88055C12.249 3.00638 11.9085 2.16829 11.3031 1.55015C10.6978 0.93202 9.87697 0.584319 9.02083 0.583334Z" />
        )}
      </svg>
      {likeCount > 0 && (
        <span className="ProductsListItem-like-count">
          {countFormat(likeCount)}
        </span>
      )}
    </button>
  );
}

ProductsListItemLikeButton.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string,
    category: PropTypes.string,
    brand: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
  isLiked: PropTypes.bool,
  likeCount: PropTypes.number,
  onLikeChange: PropTypes.func.isRequired,
};
